import { z } from "zod";
import { PfadSchema } from "./common.js";

/**
 * Phase 1 — anfrage-typ-agent (Haiku) entscheidet Pfad A vs. B.
 * Begründung pflicht für Audit + Memory-Aufbau.
 */
export const AnfrageTypSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  pfad: PfadSchema,
  begruendung: z.string(),
  /** Dateien die als LV-Quelle taugen (Pfad A). */
  lvDateien: z.array(z.string()).default([]),
  /** Dateien die als Architektur-Plan taugen (Pfad B). */
  planDateien: z.array(z.string()).default([]),
  /** Sonstige Dateien (Mail-Body, Bilder, ...). */
  sonstigeDateien: z.array(z.string()).default([]),
  /** Heuristik-Match oder LLM-Entscheidung? */
  entscheidungsModus: z.enum(["heuristik", "llm"]).default("heuristik"),
});

export type AnfrageTyp = z.infer<typeof AnfrageTypSchema>;
